import { JSX } from 'react'

import { IconProps } from '../../icon'

const Default: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M27.1666 33V32.4667H21.8333V33C21.8333 35.3584 20.9917 37.2667 18.6333 37.2667V38.3333H30.3666V37.2667C28.0082 37.2667 27.1666 35.3584 27.1666 33Z'
      fill='#E7ECED'
    />
    <path
      d='M35.7 9.53333H13.3H10.6339C9.75013 9.53333 9.03333 10.2501 9.03333 11.1339V29.2667H13.3H21.3H27.7H35.7H39.9667V11.1339C39.9667 10.2501 39.2499 9.53333 38.3661 9.53333H35.7Z'
      fill='#E7ECED'
    />
    <path d='M11.1667 11.6667H37.8334V28.7334H11.1667V11.6667Z' fill='white' />
    <path
      d='M38.3661 33H10.6339C9.75013 33 9.03333 32.2832 9.03333 31.3995V28.7333H39.9667V31.3995C39.9667 32.2832 39.2499 33 38.3661 33Z'
      fill='#AFB6BB'
    />
    <path
      d='M31.4333 39.4H17.5667C16.9773 39.4 16.5 38.9227 16.5 38.3333C16.5 37.744 16.9773 37.2667 17.5667 37.2667H31.4333C32.0227 37.2667 32.5 37.744 32.5 38.3333C32.5 38.9227 32.0227 39.4 31.4333 39.4Z'
      fill='#AFB6BB'
    />
    <path
      d='M24.5 22.3333L18.1 19.3216V23.4L24.5 26.6L30.9 23.4V19.3216L24.5 22.3333Z'
      fill='#32597F'
    />
    <path
      d='M24.5 13.8L15.4333 18.0667L24.5 22.3333L33.5667 18.0667L24.5 13.8Z'
      fill='#366DB6'
    />
    <path
      d='M24.5 22.8667C24.4222 22.8667 24.3448 22.8496 24.2728 22.816L15.2062 18.5493C15.0195 18.4613 14.9 18.2731 14.9 18.0667C14.9 17.8603 15.0195 17.672 15.2062 17.584L24.2728 13.3173C24.4168 13.2496 24.5832 13.2496 24.7272 13.3173L33.7939 17.584C33.9806 17.672 34.1 17.8603 34.1 18.0667C34.1 18.2731 33.9806 18.4613 33.7939 18.5493L24.7272 22.816C24.6552 22.8496 24.5779 22.8667 24.5 22.8667ZM16.6862 18.0667L24.5 21.744L32.3139 18.0667L24.5 14.3893L16.6862 18.0667Z'
      fill='#4D007E'
    />
    <path
      d='M24.5 27.1333C24.4184 27.1333 24.3363 27.1146 24.2616 27.0773L17.8616 23.8773C17.6808 23.7866 17.5667 23.6021 17.5667 23.4V19.3216C17.5667 19.1392 17.66 18.969 17.8141 18.8714C17.9683 18.7733 18.1619 18.7621 18.3267 18.8389L24.5 21.744L30.6728 18.8389C30.8381 18.7616 31.0317 18.7733 31.1853 18.8714C31.34 18.969 31.4333 19.1392 31.4333 19.3216V23.4C31.4333 23.6021 31.3192 23.7866 31.1384 23.8773L24.7384 27.0773C24.6637 27.1146 24.5816 27.1333 24.5 27.1333ZM18.6333 23.0704L24.5 26.0037L30.3667 23.0704V20.1621L24.7272 22.816C24.5832 22.8837 24.4168 22.8837 24.2728 22.816L18.6333 20.1621V23.0704Z'
      fill='#4D007E'
    />
    <path
      d='M33.5667 18.6H24.5C24.2056 18.6 23.9667 18.3611 23.9667 18.0667C23.9667 17.7723 24.2056 17.5333 24.5 17.5333H33.5667C33.8611 17.5333 34.1 17.7723 34.1 18.0667C34.1 18.3611 33.8611 18.6 33.5667 18.6Z'
      fill='#4D007E'
    />
    <path
      d='M33.5667 23.4C33.2723 23.4 33.0333 23.1611 33.0333 22.8667V18.0667C33.0333 17.7723 33.2723 17.5333 33.5667 17.5333C33.8611 17.5333 34.1 17.7723 34.1 18.0667V22.8667C34.1 23.1611 33.8611 23.4 33.5667 23.4Z'
      fill='#4D007E'
    />
    <path
      d='M24.5 19.6667C24.2056 19.6667 23.9667 19.4277 23.9667 19.1333V17C23.9667 16.7056 24.2056 16.4667 24.5 16.4667C24.7944 16.4667 25.0333 16.7056 25.0333 17V19.1333C25.0333 19.4277 24.7944 19.6667 24.5 19.6667Z'
      fill='#4D007E'
    />
    <path
      d='M32.4995 25C32.3982 25 32.2953 24.9712 32.2041 24.9104C31.9593 24.7472 31.8931 24.416 32.0563 24.1706L33.123 22.5706C33.2862 22.3253 33.6169 22.2586 33.8627 22.4229C34.1075 22.5861 34.1737 22.9173 34.0105 23.1626L32.9438 24.7626C32.8409 24.9168 32.6718 25 32.4995 25Z'
      fill='#4D007E'
    />
    <path
      d='M34.6339 25C34.4616 25 34.2926 24.9168 34.1896 24.7626L33.123 23.1626C32.9598 22.9178 33.0259 22.5861 33.2707 22.4229C33.5155 22.2586 33.8467 22.3253 34.0104 22.5706L35.0771 24.1706C35.2403 24.4154 35.1742 24.7472 34.9294 24.9104C34.8382 24.9712 34.7352 25 34.6339 25Z'
      fill='#4D007E'
    />
    <path
      d='M24.5 24.4667C24.2056 24.4667 23.9667 24.2277 23.9667 23.9333V22.3333C23.9667 22.0389 24.2056 21.8 24.5 21.8C24.7944 21.8 25.0333 22.0389 25.0333 22.3333V23.9333C25.0333 24.2277 24.7944 24.4667 24.5 24.4667Z'
      fill='#4D007E'
    />
    <path
      d='M39.9667 29.2667H9.03333C8.73893 29.2667 8.5 29.0277 8.5 28.7333V11.1339C8.5 9.95733 9.45733 9 10.6339 9H38.3661C39.5427 9 40.5 9.95733 40.5 11.1339V28.7333C40.5 29.0277 40.2611 29.2667 39.9667 29.2667ZM9.56667 28.2H39.4333V11.1339C39.4333 10.5451 38.9549 10.0667 38.3661 10.0667H10.6339C10.0451 10.0667 9.56667 10.5451 9.56667 11.1339V28.2Z'
      fill='#4D007E'
    />
    <path
      d='M38.3661 33.5333H10.6339C9.45733 33.5333 8.5 32.576 8.5 31.3995V28.7333C8.5 28.4389 8.73893 28.2 9.03333 28.2H39.9667C40.2611 28.2 40.5 28.4389 40.5 28.7333V31.3995C40.5 32.576 39.5427 33.5333 38.3661 33.5333ZM9.56667 29.2667V31.3995C9.56667 31.9883 10.0451 32.4667 10.6339 32.4667H38.3661C38.9549 32.4667 39.4333 31.9883 39.4333 31.3995V29.2667H9.56667Z'
      fill='#4D007E'
    />
    <path
      d='M26.1 31.4H22.9C22.6056 31.4 22.3667 31.161 22.3667 30.8666C22.3667 30.5722 22.6056 30.3333 22.9 30.3333H26.1C26.3944 30.3333 26.6334 30.5722 26.6334 30.8666C26.6334 31.161 26.3944 31.4 26.1 31.4Z'
      fill='#4D007E'
    />
    <path
      d='M37.8334 29.2667H11.1667C10.8723 29.2667 10.6334 29.0278 10.6334 28.7334V11.6667C10.6334 11.3723 10.8723 11.1334 11.1667 11.1334H37.8334C38.1278 11.1334 38.3667 11.3723 38.3667 11.6667V28.7334C38.3667 29.0278 38.1278 29.2667 37.8334 29.2667ZM11.7 28.2H37.3V12.2H11.7V28.2Z'
      fill='#4D007E'
    />
    <path
      d='M31.4333 39.9333H17.5667C16.6845 39.9333 15.9667 39.2155 15.9667 38.3333C15.9667 37.4512 16.6845 36.7333 17.5667 36.7333H31.4333C32.3155 36.7333 33.0333 37.4512 33.0333 38.3333C33.0333 39.2155 32.3155 39.9333 31.4333 39.9333ZM17.5667 37.8C17.2728 37.8 17.0333 38.0395 17.0333 38.3333C17.0333 38.6272 17.2728 38.8667 17.5667 38.8667H31.4333C31.7272 38.8667 31.9667 38.6272 31.9667 38.3333C31.9667 38.0395 31.7272 37.8 31.4333 37.8H17.5667Z'
      fill='#4D007E'
    />
    <path
      d='M30.3666 37.8H18.6333C18.3389 37.8 18.1 37.5611 18.1 37.2667C18.1 36.9723 18.3389 36.7333 18.6333 36.7333C20.4029 36.7333 21.3 35.4773 21.3 33C21.3 32.7056 21.5389 32.4667 21.8333 32.4667H27.1666C27.461 32.4667 27.7 32.7056 27.7 33C27.7 35.4773 28.597 36.7333 30.3666 36.7333C30.661 36.7333 30.9 36.9723 30.9 37.2667C30.9 37.5611 30.661 37.8 30.3666 37.8ZM21.2312 36.7333H27.7693C27.1122 36.0059 26.7256 34.9227 26.6482 33.5333H22.3522C22.2744 34.9227 21.8882 36.0059 21.2312 36.7333Z'
      fill='#4D007E'
    />
  </svg>
)

export default Default
